/**
 * Veluna PDP offer - one plain, literally true discount offer on product pages.
 *
 * REBUILT 2026-09-23 (popup CRO pass). The previous version was a "mystery"
 * scratch card that said "a single discount, randomly assigned" while the
 * only prize configured was SLEEP10. It also auto-added the product to the
 * cart and redirected to checkout. All of that is gone:
 *   - no mystery / random framing, no scratch mechanic, no confetti
 *   - the offer is stated up front: 10% off a one-time order
 *   - the code is SHOWN, plainly, after the email is accepted (2xx only)
 *   - nothing is added to the cart and nobody is redirected anywhere
 *
 * SLEEP10 as configured in Shopify admin (checked 2026-09-23): 10% off
 * one-time purchase products, not subscriptions, one use per customer, does
 * not combine with other discounts. The legal line below says exactly that.
 * The code and percent still come from the pdp-mystery-popup section settings.
 *
 * Trigger: 30 s on the page or 50% scroll, whichever comes first, and only
 * when VelunaCaptureGuard allows it (never over the buy box, never after an
 * add-to-cart this session, never after a capture). Any dismissal suppresses
 * it for 7 days and for the rest of the session.
 *
 * REDESIGNED 2026-10-01 (owner-approved mock, markup and CSS only): bone card
 * with a linen media panel showing the product's own picture (its __linen file
 * when it has one), a bottom sheet with a product thumbnail on phones, the
 * email step first and the code in a dashed box with a Copy button. Triggers,
 * suppression, measurement, the guard registration (pdp-mystery) and the POST
 * body are unchanged.
 *
 * The file name and the section are unchanged so rollback is one asset.
 * The legacy checkout interceptor below is kept ONLY for visitors who already
 * hold a code from the old flow (veluna_pdp_mystery_won); new signups never
 * write that key.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('veluna-pdp-mystery-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (_) { return; }
  if (!CFG || !CFG.product) return;

  var OFFER = (CFG.prizes || []).filter(function (p) { return p && p.code && p.percent > 0; })[0] || null;

  var STORAGE = {
    legacyWon: 'veluna_pdp_mystery_won',
    offer: 'veluna_pdp_offer_code',
    dismissedUntil: 'veluna_pdp_offer_dismissed_until',
    sessionDismissed: 'veluna_pdp_offer_dismissed_session',
    captured: 'veluna_email_captured'
  };
  var SUPPRESS_MS = 7 * 24 * 60 * 60 * 1000;
  var DWELL_MS = 30000;
  var SCROLL_FRACTION = 0.5;
  var CAPTURE_ID = 'pdp-mystery';

  try {
    if (/\/products\//.test(window.location.pathname)) {
      (window.__vlnPageSpecific = window.__vlnPageSpecific || []).push(CAPTURE_ID);
      window.VelunaCaptureGuard && window.VelunaCaptureGuard.registerPageSpecific(CAPTURE_ID);
    }
  } catch (e) {}

  var BACKEND = {
    url: 'https://ary09mimgg.execute-api.us-east-2.amazonaws.com/Prod/subscribe',
    sequence: 'pdp_offer',
    popupVariant: 'pdp_offer_v2',
    source: 'veluna_pdp_offer'
  };

  /* Product handle -> concern code. Sets first, then the specific products.
     sleep-plus-collagen-cream must be tested before the generic collagen rule. */
  var CONCERN_NAMES = { mc: 'Mind Calm', dr: 'Deep Restore', ss: 'Sacred Soothe' };
  function concernFor(handle) {
    var h = String(handle || '').toLowerCase();
    if (h.indexOf('mind-calm') !== -1) return 'mc';
    if (h.indexOf('deep-restore') !== -1) return 'dr';
    if (h.indexOf('sacred-soothe') !== -1) return 'ss';
    if (/hyaluronic|sleep-plus|gummies/.test(h)) return 'ss';
    if (/recovery-cream|collagen/.test(h)) return 'dr';
    if (/sleep-formula|magnesium-glycinate|ashwagandha|sleep-strips/.test(h)) return 'mc';
    return '';
  }
  var CONCERN = concernFor(CFG.product.handle);

  function ls(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (_) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }

  var CAPTURE_RECENT_MS = 30 * 24 * 60 * 60 * 1000;
  function isCaptured() {
    var any = ls(STORAGE.captured) === 'true' || !!ls('veluna_pdf_captured') || !!ls(STORAGE.offer) ||
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((ls('veluna_quiz_email') || '').trim());
    if (!any) return false;
    /* 2026-10-01: a visitor whose capture is older than 30 days may be offered the code
       again (veluna_pdf_captured = '<email>|<ms>', veluna_pdp_offer_code carries ts).
       An unknown age counts as recent. The guard applies the same rule for this engine. */
    var ms = parseInt((ls('veluna_pdf_captured') || '').split('|')[1] || '0', 10) || 0, ts = 0;
    try { ts = (JSON.parse(ls(STORAGE.offer) || 'null') || {}).ts || 0; } catch (_) {}
    var newest = Math.max(ms, ts);
    return !(newest > 0 && Date.now() - newest > CAPTURE_RECENT_MS);
  }
  function isDismissed() {
    if (ssGet(STORAGE.sessionDismissed)) return true;
    var until = parseInt(ls(STORAGE.dismissedUntil) || '0', 10);
    return !!until && Date.now() < until;
  }
  function hasLegacyWin() { return !!ls(STORAGE.legacyWon); }

  function fireLead(p) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', p); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', source: p.source, concern: p.concern, surface: p.surface }); } catch (_) {}
  }
  function push(ev, extra) {
    try {
      if (!window.dataLayer) return;
      var o = { event: ev, product_handle: CFG.product.handle };
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) o[k] = extra[k];
      window.dataLayer.push(o);
    } catch (_) {}
  }
  /* 2026-10-01: popup measurement shared with every capture engine (gtag only; the
     dataLayer pushes above stay). */
  function gaPopup(ev, p) { try { if (typeof window.gtag === 'function') window.gtag('event', ev, p); } catch (_) {} }
  function triggerName(r) {
    r = String(r || '');
    if (r === 'scroll-depth') return 'scroll';
    if (r === 'exit-intent' || r === 'dwell' || r === 'scroll-up' || r === 'idle') return r;
    return 'manual';
  }

  /* ---------- styles (this CSS lives in a JS string) ----------
     2026-10-01 redesign, the same card system as the guide popup. Families from the
     theme's variables (--veluna-serif / --veluna-ui / --veluna-mono) with literal
     fallbacks; !important because several theme stylesheets load asynchronously.
     Hooks kept: .vpm__overlay(.is-open), .vpm__card, .vpm__close, .vpm__frame[data-body],
     #vpm-email, .vpm__btn[data-submit], [data-code], [data-copy], [data-copied], data-skip, data-done. */
  function injectStyles() {
    if (document.getElementById('vpm-styles')) return;
    var SERIF = 'var(--veluna-serif,Newsreader,Georgia,serif)!important';
    var UI = 'var(--veluna-ui,"Hanken Grotesk",system-ui,sans-serif)!important';
    var MONO = 'var(--veluna-mono,"DM Mono",ui-monospace,monospace)!important';
    var O = '.vpm__overlay ';
    var css = [
      '.vpm__overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(27,27,27,.45);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;opacity:0;transition:opacity .25s ease;}',
      '.vpm__overlay.is-open{opacity:1;}',
      '.vpm__overlay *,.vpm__overlay *::before,.vpm__overlay *::after{box-sizing:border-box;}',
      '.vpm__card{position:relative;display:grid;grid-template-columns:300px minmax(0,1fr);width:100%;max-width:760px;max-height:92vh;overflow:auto;background:#FBF9F5;color:#131313;border:1px solid #ECE7DF;border-radius:18px;box-shadow:0 30px 80px rgba(20,20,20,.35);text-align:left;font-family:' + UI + ';transform:translateY(10px);transition:transform .25s ease;}',
      '.vpm__overlay.is-open .vpm__card{transform:none;}',
      '.vpm__handle{display:none;width:40px;height:4px;border-radius:2px;background:#D5CFC4;margin:14px auto 0;}',
      '.vpm__media{display:flex;align-items:center;justify-content:center;padding:28px;background:#E9DDD1;}',
      '.vpm__media img{display:block;width:auto;height:auto;max-width:100%;max-height:360px;border-radius:8px;box-shadow:0 12px 30px rgba(0,0,0,.18);}',
      '.vpm__media--empty{display:none;}',
      '.vpm__card--nomedia{grid-template-columns:minmax(0,1fr);max-width:520px;}',
      '.vpm__frame{min-width:0;padding:34px 36px 30px;text-align:left;}',
      O + '.vpm__close{position:absolute;top:14px;right:14px;width:36px;height:36px;display:flex;align-items:center;justify-content:center;padding:0;margin:0;background:transparent;border:0;border-radius:50%;cursor:pointer;color:#6A6D78;line-height:0;}',
      O + '.vpm__close:hover{color:#131313;background:rgba(19,19,19,.06);}',
      '.vpm__head{display:flex;align-items:center;gap:14px;}',
      '.vpm__head-text{min-width:0;flex:1 1 auto;}',
      '.vpm__thumb{display:none;flex:0 0 64px;width:64px;height:84px;object-fit:cover;border-radius:6px;box-shadow:0 6px 16px rgba(0,0,0,.18);background:#E9DDD1;}',
      O + '.vpm__brand{margin:0 0 14px;font-family:' + MONO + ';font-weight:500;font-size:11px;line-height:1;letter-spacing:.14em;text-transform:uppercase;color:#9A7B55;}',
      O + '.vpm__h{margin:0 0 12px;font-family:' + SERIF + ';font-weight:500!important;font-size:30px;line-height:1.15;letter-spacing:-.01em;color:#131313!important;text-wrap:balance;}',
      O + '.vpm__sub{margin:0 0 20px;max-width:none;font-family:' + UI + ';font-size:16px;line-height:1.5;color:#4a4d57;}',
      '.vpm__form{display:flex;flex-direction:column;gap:0;text-align:left;margin:0;}',
      '.vpm__row{display:flex;gap:10px;}',
      '.vpm__label{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;}',
      O + '.vpm__input{flex:1 1 auto;min-width:0;width:100%;height:50px;min-height:50px;margin:0;padding:0 16px;border:1px solid #D5CFC4;border-radius:12px;background:#fff;color:#1b1b1b;font-family:' + UI + ';font-size:16px;line-height:normal;box-shadow:none;-webkit-appearance:none;appearance:none;}',
      O + '.vpm__input::placeholder{color:#8A8D98;opacity:1;}',
      O + '.vpm__input:focus{outline:2px solid #C8A27B;outline-offset:1px;border-color:#C8A27B;}',
      O + '.vpm__btn{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;width:auto;height:50px;min-height:50px;margin:0;padding:0 22px;border:0;border-radius:12px;background:#C8A27B;color:#131313;font-family:' + UI + ';font-size:16px;font-weight:600;line-height:1;white-space:nowrap;cursor:pointer;text-decoration:none;-webkit-appearance:none;appearance:none;}',
      O + '.vpm__btn:hover{background:#BE966D;color:#131313;}',
      O + '.vpm__btn[disabled]{opacity:.6;cursor:wait;}',
      O + '.vpm__error{min-height:0;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#A5522B;}',
      O + '.vpm__error:not(:empty){margin-top:8px;}',
      O + '.vpm__legal{margin:12px 0 0;font-family:' + UI + ';font-size:12.5px;line-height:1.5;color:#6A6D78;text-align:left;}',
      O + '.vpm__skip{display:inline-block;margin:14px 0 0;padding:0;background:transparent;border:0;cursor:pointer;font-family:' + UI + ';font-size:14px;line-height:1.4;color:#6A6D78;text-decoration:underline;text-underline-offset:3px;}',
      O + '.vpm__skip:hover{color:#131313;}',
      '.vpm__code-row{display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin:6px 0 10px;}',
      O + '.vpm__code{display:inline-block;margin:0;padding:10px 16px;background:#fff;border:1px dashed #C8A27B;border-radius:10px;font-family:' + MONO + ';font-weight:500;font-size:26px;line-height:1;letter-spacing:.06em;color:#131313;user-select:all;-webkit-user-select:all;}',
      O + '.vpm__copy{height:44px;margin:0;padding:0 16px;border:1px solid #D5CFC4;border-radius:10px;background:#fff;color:#131313;font-family:' + UI + ';font-size:14px;font-weight:600;line-height:1;cursor:pointer;-webkit-appearance:none;appearance:none;}',
      O + '.vpm__copy:hover{border-color:#C8A27B;}',
      O + '.vpm__copied{min-height:0;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#4a4d57;}',
      O + '.vpm__copied:not(:empty){margin:0 0 10px;}',
      '.vpm__links{display:flex;flex-wrap:wrap;gap:10px;margin:14px 0 0;}',
      O + '.vpm__link{display:inline-block;margin:0;padding:11px 16px;border:1px solid #D5CFC4;border-radius:12px;background:#fff;color:#131313;font-family:' + UI + ';font-size:15px;font-weight:600;line-height:1.2;text-decoration:none;}',
      O + '.vpm__link:hover{border-color:#C8A27B;color:#131313;}',
      O + '.vpm__close:focus-visible,' + O + '.vpm__btn:focus-visible,' + O + '.vpm__skip:focus-visible,' + O + '.vpm__copy:focus-visible,' + O + '.vpm__link:focus-visible{outline:2px solid #C8A27B;outline-offset:3px;}',
      '@media (max-width:860px){.vpm__card{grid-template-columns:240px minmax(0,1fr);}.vpm__card--nomedia{grid-template-columns:minmax(0,1fr);}.vpm__frame{padding:28px 26px 24px;}.vpm__media{padding:22px;}}',
      /* Phone: a bottom sheet, full width, product thumbnail beside the headline. */
      '@media (max-width:640px){' +
        '.vpm__overlay{align-items:flex-end;padding:0;}' +
        '.vpm__card{display:block;max-width:none;width:100%;max-height:92vh;border-radius:22px 22px 0 0;border-bottom:0;box-shadow:0 -20px 60px rgba(0,0,0,.3);transform:translateY(24px);}' +
        '.vpm__handle{display:block;}' +
        '.vpm__media{display:none;}' +
        '.vpm__frame{padding:14px 20px 28px;}' +
        O + '.vpm__close{top:10px;right:10px;}' +
        '.vpm__head{margin:0 0 10px;padding-right:28px;}' +
        '.vpm__thumb{display:block;}' +
        '.vpm__thumb--empty{display:none;}' +
        O + '.vpm__brand{margin:0 0 6px;}' +
        O + '.vpm__h{margin:0;font-size:24px;}' +
        O + '.vpm__sub{margin:0 0 14px;font-size:15px;}' +
        '.vpm__row{flex-direction:column;gap:10px;}' +
        O + '.vpm__input{height:52px;min-height:52px;}' +
        O + '.vpm__btn{width:100%;height:52px;min-height:52px;}' +
        O + '.vpm__code{font-size:22px;}' +
      '}',
      '@media (prefers-reduced-motion:reduce){.vpm__overlay,.vpm__card{transition:none;}.vpm__card{transform:none;}}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'vpm-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---------- views ---------- */
  function legalLine() {
    return 'One use per customer. Works on a one-time set or the first delivery of a plan. ' +
      'Combines with free shipping only. No spam, unsubscribe anytime.';
  }
  /* 2026-10-01: the product's own picture for the media panel. Its __linen file when
     it has one (the featured image from the section config first, then this page's
     own gallery, matched on the product handle so a cross-sell card's linen shot is
     never picked), else the featured image, else the product JSON-LD image, else the
     first gallery image. CDN width is capped at 600 (the panel renders 244 px wide). */
  function cdnWidth(u, w) {
    u = String(u || '');
    if (!/cdn\/shop\/|cdn\.shopify\.com/.test(u)) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function productImage() {
    var handle = String(CFG.product.handle || '').toLowerCase();
    var feat = String(CFG.product.image || '');
    if (/__linen\./i.test(feat)) return cdnWidth(feat, 600);
    try {
      var imgs = document.querySelectorAll('img[src*="__linen"],img[srcset*="__linen"],img[data-src*="__linen"]');
      for (var i = 0; i < imgs.length; i++) {
        var src = imgs[i].currentSrc || imgs[i].getAttribute('src') || imgs[i].getAttribute('data-src') || '';
        if (src.indexOf('__linen') === -1) src = ((imgs[i].getAttribute('srcset') || '').split(',')[0] || '').trim().split(' ')[0];
        if (handle && src.toLowerCase().indexOf('/' + handle + '__linen') !== -1) return cdnWidth(src, 600);
      }
    } catch (_) {}
    if (feat) return cdnWidth(feat, 600);
    try {
      var lds = document.querySelectorAll('script[type="application/ld+json"]');
      for (var k = 0; k < lds.length; k++) {
        var d = JSON.parse(lds[k].textContent || 'null');
        var list = Array.isArray(d) ? d : (d && d['@graph']) ? d['@graph'] : [d];
        for (var m = 0; m < list.length; m++) {
          var o = list[m];
          if (o && o['@type'] === 'Product' && o.image) {
            var im = Array.isArray(o.image) ? o.image[0] : o.image;
            return String((im && im.url) || im || '');
          }
        }
      }
    } catch (_) {}
    var g = document.querySelector('.product__media img,.product-gallery img,[data-product-gallery] img,.pdp-gallery img,main img');
    return g ? (g.currentSrc || g.getAttribute('src') || '') : '';
  }
  var PRODUCT_IMAGE = null;
  function productImageUrl() { if (PRODUCT_IMAGE === null) PRODUCT_IMAGE = productImage() || ''; return PRODUCT_IMAGE; }
  /* "works until" date: the engine's value as given, or a readable date when it is
     an ISO timestamp (2026-10-08T23:59:00-04:00 -> Thursday, October 8). */
  function endsLabel(s) {
    s = String(s || '');
    if (!/^\d{4}-\d{2}-\d{2}/.test(s)) return s;
    var d = new Date(s);
    if (isNaN(d.getTime())) return s;
    try { return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }); } catch (_) { return s; }
  }
  /* Thumbnail + eyebrow + headline. The thumbnail shows only on phones (the media
     panel shows the same picture on desktop). */
  function viewHead(eyebrow, h) {
    var u = productImageUrl();
    return '<div class="vpm__head">' +
      (u ? '<img class="vpm__thumb" src="' + esc(u) + '" alt="' + esc(CFG.product.title) + '" width="64" height="84" decoding="async" />' : '') +
      '<div class="vpm__head-text"><p class="vpm__brand">' + eyebrow + '</p>' +
      '<h2 class="vpm__h" id="vpm-title">' + h + '</h2></div></div>';
  }
  function viewOffer() {
    return '' +
      viewHead('First set', esc(OFFER.percent) + '% off your first set') +
      '<p class="vpm__sub">Enter your email and your code appears right here, ready for checkout.</p>' +
      '<form class="vpm__form" data-form novalidate>' +
        '<label class="vpm__label" for="vpm-email">Email address</label>' +
        '<div class="vpm__row">' +
        '<input class="vpm__input" id="vpm-email" type="email" name="email" placeholder="you@example.com" required autocomplete="email" />' +
        '<button class="vpm__btn" type="submit" data-submit>Show my code</button>' +
        '</div>' +
        '<p class="vpm__error" data-error role="status" aria-live="polite"></p>' +
      '</form>' +
      '<p class="vpm__legal">' + esc(legalLine()) + '</p>' +
      '<button class="vpm__skip" type="button" data-skip>No thanks</button>';
  }
  var MINE = null; /* 2026-10-01: the signup's own code from the engine */
  function codeNow() { return (MINE && MINE.signup_code) || OFFER.code; }
  function viewCode() {
    return '' +
      viewHead('Your code, ready now', 'Here is your ' + esc(OFFER.percent) + '% off') +
      '<div class="vpm__code-row"><span class="vpm__code" data-code>' + esc(codeNow()) + '</span>' +
      '<button class="vpm__copy" type="button" data-copy>Copy</button></div>' +
      '<p class="vpm__copied" data-copied role="status" aria-live="polite"></p>' +
      '<p class="vpm__sub">' + (MINE && MINE.signup_code ? 'Your own code, works until ' + esc(endsLabel(MINE.signup_ends || '')) + '. ' : '') +
      'Enter it at checkout, on a one-time set or the first delivery of a plan.</p>' +
      '<div class="vpm__links"><a class="vpm__link" href="/pages/ritual-essentials" data-sets-link>See the sets</a></div>' +
      '<p class="vpm__legal">' + esc(legalLine().replace(' No spam, unsubscribe anytime.', '')) + '</p>' +
      '<button class="vpm__skip" type="button" data-done>Back to the product</button>';
  }

  /* ---------- build / open / close ---------- */
  var overlay = null, isOpen = false, releaseFocus = null, shownOnce = false;

  function render(html) { overlay.querySelector('[data-body]').innerHTML = html; }

  function build() {
    if (overlay) return overlay;
    injectStyles();
    overlay = document.createElement('div');
    overlay.className = 'vpm__overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'vpm-title');
    overlay.setAttribute('data-capture-id', CAPTURE_ID);
    var img = productImageUrl();
    overlay.innerHTML = '<div class="vpm__card' + (img ? '' : ' vpm__card--nomedia') + '">' +
      '<span class="vpm__handle" aria-hidden="true"></span>' +
      '<div class="vpm__media' + (img ? '' : ' vpm__media--empty') + '">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(CFG.product.title) + '" width="300" height="300" decoding="async" />' : '') + '</div>' +
      '<button class="vpm__close" type="button" data-close aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button><div class="vpm__frame" data-body></div></div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) { close('backdrop'); return; }
      if (e.target.closest('[data-close]')) { close('close-btn'); return; }
      if (e.target.closest('[data-skip]')) { close('skip'); return; }
      if (e.target.closest('[data-done]')) { close('done'); return; }
      if (e.target.closest('[data-copy]')) { copyCode(); }
    });
    overlay.addEventListener('submit', function (e) {
      if (e.target.matches('[data-form]')) { e.preventDefault(); onEmailSubmit(e.target); }
    });
    document.addEventListener('keydown', function (e) {
      if (isOpen && (e.key === 'Escape' || e.key === 'Esc')) close('esc');
    });
    document.body.appendChild(overlay);
    return overlay;
  }

  function open(reason) {
    if (!shouldShow()) return;
    build();
    render(viewOffer());
    isOpen = true;
    shownOnce = true;
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyOpen(CAPTURE_ID); } catch (_) {}
    requestAnimationFrame(function () { if (overlay) overlay.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    try {
      var G = window.VelunaCaptureGuard;
      releaseFocus = G && G.holdFocus ? G.holdFocus(overlay, { initial: '#vpm-email' }) : null;
    } catch (_) { releaseFocus = null; }
    push('veluna_pdp_offer_shown', { trigger: reason, offer_percent: OFFER.percent });
    gaPopup('veluna_popup_shown', { engine: 'pdp_offer', surface: 'pdp', trigger: triggerName(reason) });
  }

  function close(reason) {
    if (!overlay || !isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyClosed(CAPTURE_ID); } catch (_) {}
    if (!isCaptured()) {
      lsSet(STORAGE.dismissedUntil, String(Date.now() + SUPPRESS_MS));
      ssSet(STORAGE.sessionDismissed, '1');
      try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyDismissed && window.VelunaCaptureGuard.notifyDismissed(CAPTURE_ID); } catch (_) {}
      gaPopup('veluna_popup_dismissed', { engine: 'pdp_offer', surface: 'pdp' });
    }
    if (releaseFocus) { try { releaseFocus(); } catch (_) {} releaseFocus = null; }
    var el = overlay;
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); if (overlay === el) overlay = null; }, 260);
    push('veluna_pdp_offer_closed', { reason: reason });
  }

  function copyCode() {
    var note = overlay && overlay.querySelector('[data-copied]');
    function ok() { if (note) note.textContent = 'Copied. Paste it into the discount box at checkout.'; }
    function fail() { if (note) note.textContent = 'Select the code above to copy it.'; }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(codeNow()).then(ok, fail); return; }
    } catch (_) {}
    fail();
  }

  function onEmailSubmit(form) {
    var input = form.querySelector('input[type="email"]');
    var errEl = form.querySelector('[data-error]');
    var btn = form.querySelector('[data-submit]');
    var email = (input.value || '').trim();
    errEl.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { errEl.textContent = 'Please enter a full email address.'; input.focus(); return; }
    btn.disabled = true; btn.textContent = 'Sending…';
    submitToBackend(email).then(function (res) {
      if (!res || !res.ok) throw new Error('subscribe_failed');
      return res.json().catch(function () { return {}; });
    }).then(function (j) {
      if (j && j.signup_code) MINE = j;
      lsSet(STORAGE.captured, 'true');
      lsSet('veluna_pdf_captured', email + '|' + Date.now());
      lsSet(STORAGE.offer, JSON.stringify({ code: codeNow(), percent: OFFER.percent, ts: Date.now(), product: CFG.product.handle }));
      fireLead({ source: BACKEND.source, concern: CONCERN, surface: 'pdp' });
      push('veluna_lead_captured', { source: BACKEND.source, concern: CONCERN, offer_percent: OFFER.percent });
      render(viewCode());
      setTimeout(function () { var b = overlay && overlay.querySelector('[data-copy]'); if (b) { try { b.focus({ preventScroll: true }); } catch (_) {} } }, 40);
    }).catch(function () {
      errEl.textContent = 'That did not go through. Please try again.';
      btn.disabled = false; btn.textContent = 'Show my code';
    });
  }

  function submitToBackend(email) {
    var tags = [BACKEND.source, 'pdp_' + (CFG.product.handle || 'unknown'), BACKEND.sequence];
    if (CONCERN) tags.push('concern_' + CONCERN);
    var body = {
      email: email,
      topic: 'popup_subscribe',
      want_code: true,
      first_name: '',
      source: BACKEND.source,
      email_sequence: BACKEND.sequence,
      popup_variant: BACKEND.popupVariant,
      tags: tags,
      fields: {
        sleep_concern: CONCERN,
        ritual_type: CONCERN ? CONCERN_NAMES[CONCERN] : '',
        email_sequence: BACKEND.sequence,
        popup_variant: BACKEND.popupVariant,
        discount_code: OFFER.code,
        discount_percent: OFFER.percent,
        product_handle: CFG.product.handle,
        product_title: CFG.product.title,
        product_url: CFG.product.url
      },
      metadata: { page: window.location.pathname, referrer: document.referrer || '',
                  user_agent: (navigator && navigator.userAgent) || '' }
    };
    /* Top-level concern routes the welcome email. Omitted when the product
       maps to none, so the engine applies its own default. */
    if (CONCERN) body.concern = CONCERN;
    return fetch(BACKEND.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () { return null; });
  }

  /* ---------- triggers ---------- */
  var PREVIEW = /[?&]popup_preview=1\b/.test(window.location.search);
  /* An exit (pointer leaving the window) may open while the buy box is on
     screen; every other guard rule still applies. 2026-09-29. */
  var EXITING = false;
  function guardAllows(id) {
    var G = window.VelunaCaptureGuard;
    if (!G) return true;
    var r = G.reason ? G.reason(id) : (G.mayShow(id) ? null : 'blocked');
    return r === null || (EXITING && r === 'commerce_configuration_visible');
  }
  function shouldShow() {
    if (isOpen || !OFFER) return false;
    if (PREVIEW) return true;
    if (shownOnce) return false;
    if (hasLegacyWin() || isCaptured() || isDismissed()) return false;
    if (!guardAllows(CAPTURE_ID)) return false;
    return true;
  }

  function installTriggers() {
    var loadedAt = Date.now(), armed = false, poll = null;
    function scrolledHalf() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      return max > 0 && (window.scrollY || doc.scrollTop || 0) / max >= SCROLL_FRACTION;
    }
    function scrolledFraction() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      return max > 0 ? (window.scrollY || doc.scrollTop || 0) / max : 0;
    }
    function attempt(reason) {
      if (!armed) {
        if (Date.now() - loadedAt >= DWELL_MS) armed = 'dwell';
        else if (scrolledHalf()) armed = 'scroll-depth';
        else return;
      }
      if (shownOnce || isDismissed() || isCaptured()) { stop(); return; }
      if (shouldShow()) { stop(); open(reason || armed); }
    }
    function onScroll() { attempt(); }
    function stop() {
      window.removeEventListener('scroll', onScroll);
      if (poll) { clearInterval(poll); poll = null; }
    }
    /* 2026-10-01 phone triggers (coarse pointer): more than 250 px back up (cumulative)
       after half the page, or 10 s with no scroll or touch after 40% depth. Same
       shouldShow()/guard path as dwell and scroll, so the buy box on screen, an
       add-to-cart, a dismissal or a capture still refuse them. Registered before the
       dwell/scroll listener so a scroll-up is reported as such when both qualify. */
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      var reachedHalf = false, reached40 = false, upAcc = 0, idleTimer = null;
      var lastY = window.scrollY || document.documentElement.scrollTop || 0;
      var phone = function (reason) {
        if (shownOnce || isDismissed() || isCaptured()) return;
        if (shouldShow()) { stop(); open(reason); }
      };
      var armIdle = function () {
        if (idleTimer) clearTimeout(idleTimer);
        idleTimer = setTimeout(function () { idleTimer = null; if (reached40) phone('idle'); }, 10000);
      };
      window.addEventListener('scroll', function () {
        var y = window.scrollY || document.documentElement.scrollTop || 0, f = scrolledFraction();
        if (f >= 0.5) reachedHalf = true;
        if (f >= 0.4) reached40 = true;
        if (y < lastY) upAcc += lastY - y; else upAcc = 0;
        lastY = y;
        if (reachedHalf && upAcc > 250) { upAcc = 0; phone('scroll-up'); }
        armIdle();
      }, { passive: true });
      document.addEventListener('touchstart', armIdle, { passive: true });
      document.addEventListener('touchmove', armIdle, { passive: true });
      armIdle();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    /* Exit intent, desktop only (2026-09-29): the pointer leaves through the
       top after 5 s on the page. */
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.clientY >= 80 || Date.now() - loadedAt < 5000) return;
        if (shownOnce || isDismissed() || isCaptured()) return;
        EXITING = true;
        try { if (shouldShow()) { stop(); open('exit-intent'); } } finally { EXITING = false; }
      });
    }
    /* Once the 30 s have passed, keep checking gently: the guard refuses while
       the buy box is on screen, so the offer waits for the visitor to move on. */
    setTimeout(function () { attempt('dwell'); if (!shownOnce && !poll) poll = setInterval(function () { attempt(); }, 2000); }, DWELL_MS);
  }

  /* ---------- legacy holders of an old scratch-card code ---------- */
  function getLegacyPrize() {
    try { var d = JSON.parse(ls(STORAGE.legacyWon) || 'null'); return (d && d.code) ? d : null; } catch (_) { return null; }
  }
  function installLegacyCheckoutInterceptor() {
    if (window.__velunaCheckoutInterceptorInstalled) return;
    window.__velunaCheckoutInterceptorInstalled = true;
    document.addEventListener('click', function (e) {
      var prize = getLegacyPrize();
      if (!prize) return;
      var t = e.target && e.target.closest && e.target.closest('a[href*="/checkout"], a[href*="/cart/checkout"], button[name="checkout"], [data-checkout-button], [data-action="checkout"]');
      if (!t || t.getAttribute('data-veluna-discount-applied') === '1') return;
      e.preventDefault();
      e.stopPropagation();
      t.setAttribute('data-veluna-discount-applied', '1');
      var target = (t.tagName === 'A' && t.getAttribute('href')) ? t.getAttribute('href') : '/checkout';
      window.location.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(target);
    }, true);
  }

  /* 2026-09-30: a known subscriber viewing a product page tells the email engine (topic
     browse_abandon), at most once per product per 24 h. The email comes from any Veluna form on
     this device (veluna_pdf_captured = "<email>|<ms>"). The engine ignores unknown addresses and
     cancels the reminder if they buy. */
  function sendBrowse() {
    try {
      if (PREVIEW) return;
      var raw = localStorage.getItem('veluna_pdf_captured') || '';
      var email = raw.split('|')[0].trim().toLowerCase();
      var handle = CFG.product && CFG.product.handle;
      if (!handle || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
      var key = 'veluna_browse_sent_' + handle, last = parseInt(localStorage.getItem(key) || '0', 10);
      if (last && Date.now() - last < 24 * 60 * 60 * 1000) return;
      localStorage.setItem(key, String(Date.now()));
      var t = document.querySelector('meta[property="og:title"]');
      fetch(BACKEND.url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ topic: 'browse_abandon', email: email, product_handle: handle,
          product_name: (t && t.getAttribute('content')) || document.title || '' }) }).catch(function () {});
    } catch (_) {}
  }

  function init() {
    sendBrowse();
    if (hasLegacyWin()) { installLegacyCheckoutInterceptor(); return; }
    if (!OFFER) return;
    if (PREVIEW) { setTimeout(function () { open('preview'); }, 800); return; }
    if (isCaptured() || isDismissed()) return;
    installTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* QA helper: opens the offer regardless of storage (does not submit anything). */
  window.__velunaMysteryTest = function () {
    try {
      localStorage.removeItem(STORAGE.dismissedUntil); sessionStorage.removeItem(STORAGE.sessionDismissed);
    } catch (_) {}
    shownOnce = false;
    if (!isOpen && OFFER) { var saved = PREVIEW; PREVIEW = true; open('manual-test'); PREVIEW = saved; }
  };
})();
